module.exports = __webpack_public_path__ + "assets/img/yypt_d_p4.d409db28.png";